export default function Canvas_Clipping() {
  return (
    <div>
      <h1>Canvas_Clipping Component</h1>
    </div>
  );
}
